/*
  Sjöbergs: anmälan till nyhetsbrevet i Klaviyo.
  - [data-sjnl]: nyhetsbrevsformuläret (footer och sektionen "Nyhetsbrev med målgrupp").
  - input[data-sj-optin]: nyhetsbrevsrutan i kontakt- och offertformuläret.
  Området sparas först i profilfältet Profession, sedan läggs e-posten på listan X3Nhnd (dubbel opt-in).
  Inget laddas från Klaviyo förrän någon skickar ett formulär.
*/
(function () {
  if (window.SjNewsletter) return;

  var COMPANY = 'R4k6hW';
  var LIST = 'X3Nhnd';
  var HEADERS = { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' };
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function post(path, body, keepalive) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + COMPANY, {
      method: 'POST', headers: HEADERS, body: JSON.stringify(body), keepalive: !!keepalive
    }).then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); });
  }

  function subscribe(o, keepalive) {
    var props = { Profession: o.profession, 'Anmäld via': o.source };
    for (var k in o.props || {}) if (o.props[k]) props[k] = o.props[k];
    var attrs = { email: o.email, properties: props };
    if (o.firstName) attrs.first_name = o.firstName;
    if (o.lastName) attrs.last_name = o.lastName;
    return post('profiles', { data: { type: 'profile', attributes: attrs } }, keepalive).then(function () {
      return post('subscriptions', {
        data: {
          type: 'subscription',
          attributes: { custom_source: o.source, profile: { data: { type: 'profile', attributes: { email: o.email } } } },
          relationships: { list: { data: { type: 'list', id: LIST } } }
        }
      }, keepalive);
    });
  }

  function initForm(wrap) {
    if (wrap.dataset.sjnlReady) return;
    var form = wrap.querySelector('form');
    var select = wrap.querySelector('.sjnl__select');
    var email = wrap.querySelector('.sjnl__input');
    var status = wrap.querySelector('.sjnl__status');
    if (!form || !select || !email) return;
    wrap.dataset.sjnlReady = '1';

    function setError(name, on) {
      var field = wrap.querySelector('[data-field="' + name + '"]');
      if (field) field.classList.toggle('sjnl__field--error', on);
      (name === 'email' ? email : select).setAttribute('aria-invalid', on ? 'true' : 'false');
    }
    select.addEventListener('change', function () { setError('profession', false); });
    email.addEventListener('input', function () { setError('email', false); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (wrap.classList.contains('is-loading')) return;
      if (status) status.hidden = true;
      var address = (email.value || '').trim();
      var badProfession = !select.value;
      var badEmail = !EMAIL_RE.test(address);
      setError('profession', badProfession);
      setError('email', badEmail);
      if (badProfession) { select.focus(); return; }
      if (badEmail) { email.focus(); return; }

      wrap.classList.add('is-loading');
      subscribe({ email: address, profession: select.value, source: wrap.getAttribute('data-sjnl-source') || 'Webbplats sjobergs.se' })
        .then(function () { wrap.classList.add('is-done'); })
        .catch(function () {
          if (status) {
            status.textContent = 'Något gick fel. Försök igen om en stund, eller mejla oss på office@sjobergs.se.';
            status.hidden = false;
          }
        })
        .then(function () { wrap.classList.remove('is-loading'); });
    });
  }

  function initOptin(cb) {
    if (cb.dataset.sjOptinReady) return;
    var box = document.getElementById(cb.id + '-optin');
    var form = cb.closest('form');
    if (!box || !form) return;
    var select = box.querySelector('select');
    cb.dataset.sjOptinReady = '1';

    function sync() {
      box.hidden = !cb.checked;
      select.required = cb.checked;
      if (!cb.checked) select.selectedIndex = 0;
    }
    cb.addEventListener('change', sync);
    sync();

    function val(name) {
      var el = form.querySelector('[name="contact[' + name + ']"]');
      return el ? (el.value || '').trim() : '';
    }

    form.addEventListener('submit', function (e) {
      if (!cb.checked || !select.value || form.dataset.sjOptinSent) return;
      var address = val('email');
      if (!EMAIL_RE.test(address)) return;
      form.dataset.sjOptinSent = '1';

      var name = val('Namn').split(/\s+/).filter(Boolean);
      var payload = {
        email: address,
        profession: select.value,
        source: box.getAttribute('data-sj-source') || 'Formulär sjobergs.se',
        firstName: name[0] || '',
        lastName: name.slice(1).join(' '),
        props: {
          'Telefon (formulär)': val('Telefon'),
          'Organisation (formulär)': val('Skola/Företag'),
          'Ort (formulär)': val('Stad eller kommun')
        }
      };

      // Någon annan kod hanterar redan skickandet: anmäl i bakgrunden och stör inte.
      if (e.defaultPrevented) { subscribe(payload, true).catch(function () {}); return; }

      // Vänta på Klaviyo i högst 4 sekunder och skicka sedan formuläret som vanligt.
      e.preventDefault();
      var timeout = new Promise(function (resolve) { setTimeout(resolve, 4000); });
      Promise.race([subscribe(payload, false), timeout]).catch(function () {}).then(function () {
        if (form.requestSubmit) form.requestSubmit();
        else HTMLFormElement.prototype.submit.call(form);
      });
    });
  }

  function init(root) {
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sjnl]'), initForm);
    Array.prototype.forEach.call(root.querySelectorAll('input[data-sj-optin]'), initOptin);
  }

  window.SjNewsletter = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
